import { render } from "./TheDemandReservationsIndex.vue?vue&type=template&id=aa8ff34c&scoped=true"
import script from "./TheDemandReservationsIndex.vue?vue&type=script&lang=js"
export * from "./TheDemandReservationsIndex.vue?vue&type=script&lang=js"

import "./TheDemandReservationsIndex.vue?vue&type=style&index=0&id=aa8ff34c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-aa8ff34c"

export default script